import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import appTextIcon from "../../../assets/images/header-text-icon.svg";
import whatsappIcon from "../../../assets/images/whatsapp-icon.svg";
import workspaceAppIcon from "../../../assets/images/workspace-detail-background.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import {
  CALENDAR_RESERVATION_TYPE,
  MEMBER_BENEFITS_TYPE,
  MENU_ITEM,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import {
  getMemberBenefitsRealLifeImages,
  getTermaAndConditionsText,
} from "utils/utils";
import { STORAGE_KEY, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";
import ExpandableView from "components/elements/ExpandableView";

const CreativeSpaceDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleAppExit } = useLogout();
  const { setSelectedTabBar } = useTabBar();

  useEffect(() => {
    trackDetailView("creative_space", "CREATIVE_SPACE");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      STORAGE_KEY.CALENDAR_SELECTED_TAB,
      CALENDAR_RESERVATION_TYPE.DF_WORKSPACE,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  const openWhatsappChannel = () => {
    handleAppExit(WEB_LINK.WHATSAPP_CHANNEL);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Creative <span style={{ color: "#C2B58C" }}>Space</span>
          </span>
        </div>
        <div className="calendar_detail-app-icon-container">
          <img src={workspaceAppIcon} alt="location-logo" />
        </div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>SabeHub, Mohali</span>
                <span className="sub-text">SCO-4, 2nd Floor, Sec-68</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            bout <span style={{ color: "#C2B58C" }}>Creative Space</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span>
              Where ideas take{" "}
              <span style={{ color: "#C2B58C" }}>physical form</span>
            </span>
            <span className="sub_text">
              The Creative Space is designed for experimentation, exploration,
              and flow. A visual, tactile zone where you sketch, brainstorm,
              build mood boards, map ideas, or simply let your imagination run
              free. No rigidity — only creative freedom.
            </span>
            <span style={{ marginTop: "10px" }}>
              Ideal <span style={{ color: "#C2B58C" }}>For:</span>
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Designers
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Founders mapping new
              concepts
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Brand thinking
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Content creation
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Brain dumps & mind mapping
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Light collaboration
            </span>
            <span style={{ marginTop: "10px" }}>
              Experience <span style={{ color: "#C2B58C" }}>Promise:</span>
            </span>
            <span className="sub_text">
              You bring the spark — the space amplifies it.
            </span>
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={getMemberBenefitsRealLifeImages(
              MEMBER_BENEFITS_TYPE.CREATIVE_SPACE,
            )}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <div className="calendar_detail-contact-detail-container">
          <div className="footer-container">
            <div className="title">Contact Details</div>
            <div className="sub-container">
              <img src={appTextIcon} alt="sabe-text-logo" />
              <img
                src={whatsappIcon}
                alt="whatsapp-logo"
                onClick={openWhatsappChannel}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
        <ExpandableView title="Terms &" subTitle="Conditions">
          <div className="calendar-detail-expanded-container">
            <div className="divider"></div>
            <div className="sub-container">
              <div className="sub-title">
                {getTermaAndConditionsText(
                  CALENDAR_RESERVATION_TYPE.DF_WORKSPACE,
                )}
              </div>
            </div>
          </div>
        </ExpandableView>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Reserve Now
        </button>
      </div>
    </div>
  );
};

export default CreativeSpaceDetailScreen;
